import
{
    useEffect,
    useState
} from "react";

import
{
    SystemStatus
} from '@ews/react-data';

import
{
    useWebsocket
} from "./ReactData/ReactDataProvider";

import
{
    NetworkStatusIcon
} from './Icons';

function useNetworkStatus()
{
    const provider = useWebsocket();
    const [status, setStatus] = useState<SystemStatus>(provider.getStatus());

    useEffect(() => {
        provider.on("status", setStatus);
        return(() => {
            provider.off("status", setStatus)
        });
    }, [provider, setStatus]);

    return status
}

export const NetworkStatus = () =>
{
    const status = useNetworkStatus();
    return <NetworkStatusIcon status={status} />;

};